export default __webpack_public_path__ + "static/media/Rectangle 1040.fe7b63ea.png";